import { render, staticRenderFns } from "./full-comparison-dialog.vue?vue&type=template&id=4cff49f1"
import script from "./full-comparison-dialog.vue?vue&type=script&lang=js"
export * from "./full-comparison-dialog.vue?vue&type=script&lang=js"
import style0 from "./full-comparison-dialog.vue?vue&type=style&index=0&id=4cff49f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports